// Wrapper resiliente de Web Storage. Toda chamada e swallow-and-log em caso
// de erro (storage cheio, modo privado bloqueado, SSR sem `window`). Nunca
// lanca para nao travar boot da app — worst-case aceitavel e "usuario perde
// preferencia local", nao "app crasha".
//
// Use APENAS para preferencias e tokens auth. Para cache de queries, ver
// TanStack Query persister (out-of-scope nesta fase).

import { logger } from './logger';

export type StorageKind = 'session' | 'local';

function getStore(kind: StorageKind): globalThis.Storage | null {
  try {
    if (typeof window === 'undefined') return null;
    return kind === 'session' ? window.sessionStorage : window.localStorage;
  } catch {
    return null;
  }
}

export const storage = {
  get(key: string, kind: StorageKind = 'session'): string | null {
    try {
      return getStore(kind)?.getItem(key) ?? null;
    } catch (err) {
      logger.app.warn('storage.get failed', { key, kind, err });
      return null;
    }
  },
  set(key: string, value: string, kind: StorageKind = 'session'): void {
    try {
      getStore(kind)?.setItem(key, value);
    } catch (err) {
      logger.app.warn('storage.set failed', { key, kind, err });
    }
  },
  remove(key: string, kind: StorageKind = 'session'): void {
    try {
      getStore(kind)?.removeItem(key);
    } catch (err) {
      logger.app.warn('storage.remove failed', { key, kind, err });
    }
  },
};
